export function compareByColumnKey(a, b, key) {
  const va = a?.[key];
  const vb = b?.[key];
  if (va == null && vb == null) return 0;
  if (va == null) return 1;
  if (vb == null) return -1;
  if (typeof va === 'number' && typeof vb === 'number' && Number.isFinite(va) && Number.isFinite(vb)) {
    return va - vb;
  }
  const na = Number(va);
  const nb = Number(vb);
  if (
    Number.isFinite(na) &&
    Number.isFinite(nb) &&
    String(va).trim() !== '' &&
    String(vb).trim() !== ''
  ) {
    return na - nb;
  }
  return String(va).localeCompare(String(vb), undefined, { numeric: true, sensitivity: 'base' });
}

export function sortRowsByColumn(rows, columnKey, descending) {
  return [...rows].sort((a, b) => {
    const c = compareByColumnKey(a, b, columnKey);
    return descending ? -c : c;
  });
}

export function clientColumnSorter(dataIndex) {
  const key = Array.isArray(dataIndex) ? dataIndex[0] : dataIndex;
  return (a, b) => compareByColumnKey(a, b, key);
}

export function ensureClientSorters(columns) {
  if (!Array.isArray(columns)) return columns;
  return columns.map((col) => {
    if (!col || col.dataIndex === undefined) return col;
    if (col.sorter === false) return col;
    const key = Array.isArray(col.dataIndex) ? col.dataIndex[0] : col.dataIndex;
    if (String(key).toLowerCase() === 'action') return col;
    if (col.sorter) return col;
    return { ...col, sorter: clientColumnSorter(key) };
  });
}
